export default __webpack_public_path__ + "images/mexico-instructions_[fullhash:base64:5].png";